import { createSlice } from '@reduxjs/toolkit';

import {
  GetClientInfoType,
  ClientInfoInterface,
  FetchClientInfoType,
  FetchAdminGuideAction
} from '../actions/ClientInfo';

const initialState: ClientInfoInterface = {
  client_name: null,
  title_logo: null,
  login_logo: null,
  favicon: null,
  clientInfoReceived: false,
  state_boundary: null,
  state_name: null,
  two_factor_enabled: true,
  captcha_enabled: true
};

export const ClientInfoSlice = createSlice({
  name: 'ClientInfo',
  initialState,
  reducers: {
    getAdminGuide: (_state, _action: FetchAdminGuideAction) => {},
    getClientInfoFetch: (_state, _action: FetchClientInfoType) => {},
    getClientInfoSuccess: (state, action: GetClientInfoType) => {
      const {
        client_name,
        title_logo,
        login_logo,
        favicon,
        state_boundary,
        state_name,
        two_factor_enabled,
        captcha_enabled
      } = action.payload.clientInfo;

      state.client_name = client_name;
      state.title_logo = title_logo;
      state.login_logo = login_logo;
      state.favicon = favicon;
      state.state_boundary = state_boundary;
      state.clientInfoReceived = true;
      state.state_name = state_name;
      state.two_factor_enabled = two_factor_enabled;
      state.captcha_enabled = captcha_enabled;
    }
  }
});

export const { getAdminGuide, getClientInfoFetch, getClientInfoSuccess } =
  ClientInfoSlice.actions;

export default ClientInfoSlice.reducer;
